// extracted by mini-css-extract-plugin
module.exports = {"column":"SharedFormStyle-module__column--3UFBl","loading":"SharedFormStyle-module__loading--1Ii8K","spacer":"SharedFormStyle-module__spacer--2e9wQ"};